<ng-template #FormDeadModal>

<form class="form-validation">
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{ lang.deadlines }}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closepop()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="table-responsive" style="overflow: auto;">
      
      <table datatable [dtOptions]="datatableOptions1" class="table-striped table-sm row-border hover" id="table1">
        
        <thead>
          <tr>
            <th>S.No</th>
            <th>{{ lang.type }}</th>
            <th>{{ lang.description }}</th>
            <th>{{ lang.renewalNote }}</th>
            <th>{{ lang.created }}</th>
            <th>{{ lang.lastAction }}</th>
            <th>{{ lang.referringDate }}</th>
            <th>{{ lang.repeatingPeriod }}</th>
            <th>{{ lang.nextDeadline }}</th>
            <th>{{ lang.daysleft }}</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let record of records let i = index" id="{{record.timetabelId}}">
            <td>{{i+1}}</td>
            <td>{{record.timetable_type}}</td>
            <td><a routerLinkActive="active"  [routerLink]="['deadline/view/'+record.timetabelId]" target="_blank">{{record.timetable_discrption}}</a></td>
            <td>{{record.timetable_renewal_notes}}</td>
            <td>{{record.timetable_added_date | timeConverter : 'dd-MM-yyyy'}}</td>
            <td>{{record.last_action}}</td>
            <td>{{record.referring_date}}</td>
            <td>{{record.period}}</td>
            <td>{{record.next_deadline}}</td>
            <td>{{record.days_left}}</td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default pull-right" (click)="closepop()">{{lang.close}}</button>

  </div>

</form>



</ng-template>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
    <ngx-doc-viewer url="https://angular-doc-viewer.firebaseapp.com/assets/file-sample_150kB.pdf" viewer="google" style="width:100%;height:50vh;"></ngx-doc-viewer>
  </div>
</ng-template>